import styled from 'styled-components';

export const SwiperContainer = styled.div.attrs({
  className: 'relative'
})`
  .imageCarousel .swiper-pagination {
    position: absolute;
    bottom: -30px !important;
  }

  .imageCarousel .swiper-pagination-bullet {
    margin: 5px;
    padding: 10px 10px 0px 0px;
    border-radius: 50%;
    background-color: #4d4d4f;
    cursor: pointer;
  }

  .imageCarousel .swiper-pagination-bullet-active {
    background-color: #4d4d4f;
  }
`;
